import React from 'react';
import { Translate } from 'react-i18nify';
import styles from './index.module.scss';
const ErrorComponent = () => {
  return (
    <div className={styles.root}>
      <div className={styles.errorContainer}>
        <div className={styles.imageError}></div>
        <div className={styles.errorTexts}>
          <div className={styles.textContainer}>
            <h2>
              <Translate value="error_page_subtitle" />
            </h2>
            <p>
              <Translate value="error_page_text" />
            </p>
            <div
              className={styles.button}
              onClick={() => {
                window.location.reload();
              }}
            >
              <Translate value="reload_page" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
